module.exports = __webpack_public_path__ + "img/newrescuersnew.b2d2abc6.png";